
import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';




function AddTipoAtencion ({ handleNewTipoAtencion, editTipoAtencion, cancelarEdicion}){
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tipoAtencion, setTipoAtencion] = useState('');
    const [descripcionTipoAtencion, setDescripcionTipoAtencion] = useState('');
    const [porcentajeTerceraEdad, setPorcentajeTerceraEdad] = useState('');
    const [porcentajeCuartaEdad, setPorcentajeCuartaEdad] = useState('');
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    const { user } = useUser();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
        const fechaFormateada = obtenerFechaISOsinZ();
        // Carga inicial de datos si estamos en modo edición
        useEffect(() => {
            if (editTipoAtencion) {
                setTipoAtencion(editTipoAtencion.tipoAtencion);
                setPorcentajeTerceraEdad(editTipoAtencion.porcentajeTerceraEdad);
                setPorcentajeCuartaEdad(editTipoAtencion.porcentajeCuartaEdad);
                setDescripcionTipoAtencion(editTipoAtencion.descripcionTipoAtencion);
                setModificacion(2);
                setIngresadoPor(editTipoAtencion.ingresadoPor);
    
            } else {
                setTipoAtencion('');
                setPorcentajeTerceraEdad('');
                setPorcentajeCuartaEdad('');
                setDescripcionTipoAtencion('');
                setModificacion(1);
                setIngresadoPor('');
    
            }
        }, [editTipoAtencion]);
    
        const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editTipoAtencion ? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editTipoAtencion ? `${server}/MgTipoAtencions/${editTipoAtencion.id}` : `${server}/MgTipoAtencions`;
    
            const tipo = { 
                id:editTipoAtencion ? editTipoAtencion.id:0,
                tipoAtencion,
                porcentajeTerceraEdad,
                porcentajeCuartaEdad,
                descripcionTipoAtencion,
                IngresadoPor: !editTipoAtencion ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editTipoAtencion ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                fechaIngreso: fechaFormateada
            };
            Object.keys(tipo).forEach(key => tipo[key] === undefined && delete tipo[key]);
    
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(tipo),
                });
    
                if (response.ok) {
                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setTipoAtencion('');
                    setPorcentajeTerceraEdad('');
                    setPorcentajeCuartaEdad('');
                    setDescripcionTipoAtencion('');
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                           handleNewTipoAtencion();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar la raza',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };

    
        const handleCancelarEdicion = () => {
            setTipoAtencion('');
            setPorcentajeTerceraEdad('');
            setPorcentajeCuartaEdad('');
            setDescripcionTipoAtencion('');
            setModificacion(1);
            setIngresadoPor('');
            if (cancelarEdicion) cancelarEdicion();
        };

    return (
        <>
        {/* <h2>{editEtnia ? 'Editar Etnia' : 'Agregar Nueva Etnia'}</h2> */}
        <h2>{editTipoAtencion ? 'Editar Tipo de Atención' : 'Agregar Nueva Tipo de Atención'}</h2>
        <br />
        <form id="formTipoAtencion" className="form-horizontal form-label-left" onSubmit={handleSubmit}>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="tipoAtencion">
                    Tipo de atención: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="tipoAtencion"
                        required="required"
                        className="form-control"
                        value={tipoAtencion}
                        onChange={(e) => setTipoAtencion(e.target.value)}
                    />
                </div>
          
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcionTipoAtencion">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3">
                    <input
                        type="text"
                        id="descripcionTipoAtencion"
                        required="required"
                        className="form-control"
                        value={descripcionTipoAtencion}
                        onChange={(e) => setDescripcionTipoAtencion(e.target.value)}
                    />
                </div>
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="porcentajeTerceraEdad">
                    Porcentaje de Tercera Edad: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3 d-flex align-items-center">
                    <input
                        type="text"
                        id="porcentajeTerceraEdad"
                        required="required"
                        className="form-control"
                        value={porcentajeTerceraEdad}
                        onChange={(e) => setPorcentajeTerceraEdad(e.target.value)}
                    />
                     <span className="ms-1"> %</span>
                </div>
           
                <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="porcentajeCuartaEdad">
                    Porcentaje de Cuarta Edad: <span className="required">*</span>
                </label>
                <div className="col-md-2 col-sm-3 d-flex align-items-center">
                    <input
                        type="text"
                        id="porcentajeCuartaEdad"
                        required="required"
                        className="form-control"
                        value={porcentajeCuartaEdad}
                        onChange={(e) => setPorcentajeCuartaEdad(e.target.value)}
                    />
                    <span className="ms-1"> %</span>
                </div>
            </div>

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success">
                        {editTipoAtencion ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editTipoAtencion && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                            Cancelar
                        </button>  
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddTipoAtencion;